import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';
import { createJpdExperience } from '../../utils/experience/main.tsx';
import type { JPDExperience } from '../../utils/experience/types.tsx';

export const dialogLoad: JPDExperience = createJpdExperience(
	new UFOExperience('jpd.shared.control-dialog-load', {
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
	}),
);

export const loadStakeholders = createJpdExperience(
	new UFOExperience('jpd.shared.load-stakeholders', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const addStakeholders = createJpdExperience(
	new UFOExperience('jpd.shared.add-stakeholders', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const removeStakeholders = createJpdExperience(
	new UFOExperience('jpd.shared.remove-stakeholders', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const loadSettings = createJpdExperience(
	new UFOExperience('jpd.shared.load-settings', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const updateSettings = createJpdExperience(
	new UFOExperience('jpd.shared.update-settings', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const loadSiteConfig = createJpdExperience(
	new UFOExperience('jpd.shared.load-site-config', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const loadSitePublicSharingConfig = createJpdExperience(
	new UFOExperience('jpd.shared.load-site-public-sharing-config', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);
